import { render, staticRenderFns } from "./CadastrarProfissional.vue?vue&type=template&id=e1776a48&scoped=true&"
import script from "./CadastrarProfissional.vue?vue&type=script&lang=js&"
export * from "./CadastrarProfissional.vue?vue&type=script&lang=js&"
import style0 from "./CadastrarProfissional.vue?vue&type=style&index=0&id=e1776a48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1776a48",
  null
  
)

export default component.exports